module.exports = __webpack_public_path__ + "images/category_lp/brand/assessment_achievements/4_f36205594a59ee756865b1bba57e6f27.jpg";